import { FC } from 'react'
import { Body3, H1 } from '@/components/atoms/typography'
import { SingleIconProps } from '@/components/atoms/icon'
import { Flex } from '@/components/atoms/Grid'
import { DesktopOrTablet, MediaContextProvider } from '@/components/atoms/media'

type ListHeaderDescriptionType = {
  IconElement: (props: SingleIconProps) => JSX.Element
  text: string
}

export type ListHeaderProps = {
  title: string
  description: ListHeaderDescriptionType
}

const ListHeader: FC<ListHeaderProps> = ({ title, description }) => {
  const { IconElement, text } = description
  return (
    <Flex
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
    >
      <H1>{title}</H1>

      <MediaContextProvider>
        <DesktopOrTablet>
          <Flex flexDirection="row">
            {<IconElement />}
            <Body3 opacity={0.5} ml={12}>
              {text}
            </Body3>
          </Flex>
        </DesktopOrTablet>
      </MediaContextProvider>
    </Flex>
  )
}

export default ListHeader
